import React from 'react';
import PropTypes from 'prop-types';
import DevCollectionViewer from 'Components/ComponentLibrary/Organisms/DevCollectionViewer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const CollectionViewer = ({
  collection,
}) => {
  const { setPageContentCollection } = usePageContentContext();

  return (
    <DevCollectionViewer
      collection={collection}
      onRelationshipClick={async (rel) => {
        const coll = await rel.getRelated();
        await setPageContentCollection(coll);
      }}
    />
  );
};

CollectionViewer.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default CollectionViewer;
